import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import Select from "../../common/form/select";
import Content from "../../common/template/content";
import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import ContentCardFooter from "../../common/template/contentCardFooter";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import NewTr from "../../common/table/newTr";
import Button from "../../common/button/button";
import ButtonTable from "../../common/table/buttonTable";
import Form from "./faturaItemForm";
import FormFaturaAdicional from "./faturaAdicionalForm";
import { Loading } from "../../common/loading/loading";
import { ModalAlert } from "../../common/dialog/modalAlert";
import currency from "currency.js";

import {
    setModoTela,
    initForm,
    carregarPdfFaturaAdicional,
    salvar,
    excluir,
    getLista,
    getListaProduto,
    getListaUnidadeMedida,
    importar,
    limpar,
    redefinirTipo,
    salvarFaturaAdicional,
    excluirFaturaAdicional,
} from "./faturaItemActions";
import { useState } from "react";
import { useEffect } from "react";

function FaturaItem(props) {
    //se não tem id de fatura nao tem como buscar os itens
    if (!props.faturaFormularioValues || !props.faturaFormularioValues.id) {
        return null;
    }

    const [state, setState] = useState({
        linhaSelecionada: null,
        idItemAlteracaoTipo: null,
        id_tipo: null,
        exibirModalMercadoLivre: false,
    });

    useEffect(() => {
        props.getListaProduto();
        props.getListaUnidadeMedida();
    }, []);

    useEffect(() => {
        props.getLista(props.faturaFormularioValues.id);
    }, [props.faturaFormularioValues.id]);

    function lista() {
        if (props.aguardando) return null;

        const itemRefaturamentoExiste = props.lista.find((item) => item.id_produto == 19722); //item referente a refaturamento
        const usuarioLogado = props.usuarioLogado || {};
        const usuarioEdicao = usuarioLogado.acesso_fatura_editar || usuarioLogado.acesso_fatura_editar_fechado;
        const usuarioLogadoAdmin = [1, 2].includes(props.usuarioLogado.id); //só permite para TI ou para o marthielo
        const valorTotal = props.lista.reduce((acc, item) => {
            //não contabiliza no total dos itens o produto "Informação de Escassez Hídrica" nem "Valores Refaturados sem precisar realizar pagamentos"
            if (![19349, 19722].includes(item.id_produto)) {
                return acc.add(item.valor_total || 0);
            }
            return acc;
        }, currency(0));

        const ucFatura = props.listaUnidadeConsumidora.find((uc) => uc.id == props.faturaFormularioValues.id_unidade_consumidora) || {};
        return (
            <ContentCard>
                {!props.visualizacao ? (
                    <ContentCardHeader>
                        <Row>
                            <Grid cols="12 12 12 12" style={{ display: "flex", flexWrap: "wrap" }}>
                                <Grid cols="12 12 4 4">
                                    <Button
                                        text="Adicionar"
                                        type={"success"}
                                        disabled={props.faturaFormularioValues.importacao_validada || !usuarioEdicao}
                                        icon={"fa fa-plus"}
                                        event={() => {
                                            props.setModoTela("cadastro", {
                                                id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                            });
                                            props.initForm({
                                                id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                            });
                                        }}
                                    />
                                </Grid>

                                <Grid cols="12 12 4 4">
                                    <Button
                                        text="Importar"
                                        type={"primary"}
                                        disabled={props.faturaFormularioValues.importacao_validada || !usuarioEdicao}
                                        icon={"fa fa-file-import"}
                                        event={() => {
                                            props.setModoTela("importar", {
                                                id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                            });
                                        }}
                                    />
                                </Grid>
                                {ucFatura.id_tipo_mercado == 2 ? (
                                    <Grid cols="12 12 4 4">
                                        <Button
                                            style={{ display: "flex", height: 39, flexGrow: 1, justifyContent: "center", alignItems: "center" }}
                                            text="Importar Custos Mercado Livre"
                                            type={"info"}
                                            disabled={!usuarioLogado.acesso_fatura_adicional_adicionar} //validar permissão
                                            icon={"fa fa-folder-open"}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: true });
                                            }}
                                        />
                                    </Grid>
                                ) : null}
                                {ucFatura.geracao ? (
                                    <Grid cols="12 12 4 4">
                                        <Button
                                            text="Produção Gerador Solar (kWh)"
                                            type={"success"}
                                            disabled={props.faturaFormularioValues.importacao_validada || !usuarioEdicao}
                                            icon={"fa fa-plus"}
                                            event={() => {
                                                props.setModoTela("cadastro", {
                                                    id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                                    id_produto: 659,
                                                    id_unidade_medida: 12,
                                                });
                                                props.initForm({
                                                    id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                                    id_produto: 659,
                                                    id_unidade_medida: 12,
                                                });
                                            }}
                                        />
                                    </Grid>
                                ) : null}
                                <Grid cols="12 12 4 4">
                                    <Button
                                        text="Refaturar"
                                        type={"success"}
                                        disabled={
                                            !props.faturaFormularioValues.arquivo_pdf ||
                                            props.faturaFormularioValues.importacao_validada ||
                                            !usuarioLogado.acesso_fatura_refaturar ||
                                            itemRefaturamentoExiste
                                        }
                                        icon={"fa fa-file-invoice-dollar"}
                                        event={() => {
                                            props.setModoTela("refaturar", {
                                                id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                            });
                                        }}
                                    />
                                </Grid>

                                <Grid cols="12 12 4 4">
                                    <Button
                                        text="Limpar"
                                        type={"danger"}
                                        disabled={props.faturaFormularioValues.importacao_validada || !usuarioEdicao}
                                        icon={"fa fa-minus"}
                                        event={() => {
                                            props.setModoTela("limpar", {
                                                id_fatura: props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null,
                                            });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Row>
                    </ContentCardHeader>
                ) : null}
                <ContentCardBody>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Produto</Th>
                                <Th sticky>Tipo</Th>
                                <Th sticky>Unid Medida</Th>
                                <Th sticky alignRight>
                                    Qtd Registrada
                                </Th>
                                <Th sticky alignRight>
                                    Qtd Faturada
                                </Th>
                                <Th sticky alignRight>
                                    Tarifa
                                </Th>
                                <Th sticky alignRight>
                                    Vlr Imposto
                                </Th>
                                <Th sticky alignRight>
                                    Vlr Total
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            <NewTr
                                key={props.faturaFormularioValues.id + "-aliquota_icms"}
                                backgroundColorTr={"#FFFFFF"}
                                backgroundColorTd={"#F5F5F5"}
                                botoes={[
                                    {
                                        type: "warning",
                                        icon: "fas fa-pencil-alt",
                                        disabled: props.faturaFormularioValues.importacao_validada || props.visualizacao,
                                        event: props.exibirModalAliquotaIcms,
                                    },
                                ]}
                            >
                                <Td>Alíquota de ICMS Importada</Td>
                                <Td></Td>
                                <Td>%</Td>
                                <Td alignRight>
                                    <div
                                        style={{
                                            boxShadow: props.aliquotaIcmsDivergente ? "0px 0px 3px 1px #ff2929" : null,
                                            borderRadius: props.aliquotaIcmsDivergente ? 5 : null,
                                            padding: props.aliquotaIcmsDivergente ? 5 : null,
                                        }}
                                    >
                                        {String(props.faturaFormularioValues.icms_importado || 0)
                                            .split(".")
                                            .join(",")}
                                    </div>
                                </Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                            </NewTr>
                            <NewTr
                                key={props.faturaFormularioValues.id + "-valor_icms"}
                                backgroundColorTr={"#FFFFFF"}
                                backgroundColorTd={"#F5F5F5"}
                                botoes={[
                                    {
                                        type: "warning",
                                        icon: "fas fa-pencil-alt",
                                        disabled: props.faturaFormularioValues.importacao_validada || props.visualizacao,
                                        event: props.exibirModalValorIcms,
                                    },
                                ]}
                            >
                                <Td>Valor do ICMS Importado</Td>
                                <Td></Td>
                                <Td>R$</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td alignRight>
                                    {String(props.faturaFormularioValues.valor_icms || 0)
                                        .split(".")
                                        .join(",")}
                                </Td>
                            </NewTr>
                            {props.lista.map((item, i) => {
                                const botoesItens = [
                                    {
                                        type: "warning",
                                        icon: "fas fa-pencil-alt",
                                        disabled: props.faturaFormularioValues.importacao_validada || props.visualizacao,
                                        event: () => {
                                            let registro = {
                                                ...item,
                                                quantidade_registrada: String(item.quantidade_registrada || 0)
                                                    .split(".")
                                                    .join(","),
                                                quantidade_faturada: String(item.quantidade_faturada || 0)
                                                    .split(".")
                                                    .join(","),
                                                tarifa: String(item.tarifa || 0)
                                                    .split(".")
                                                    .join(","),
                                                valor_imposto: String(item.valor_imposto || 0)
                                                    .split(".")
                                                    .join(","),
                                                valor_total: String(item.valor_total || 0)
                                                    .split(".")
                                                    .join(","),
                                            };
                                            props.setModoTela("cadastro", registro);
                                            props.initForm(registro);
                                        },
                                    },
                                    {
                                        type: "danger",
                                        icon: "fas fa-trash-alt",
                                        disabled: props.faturaFormularioValues.importacao_validada || props.visualizacao || !usuarioEdicao,
                                        event: () => {
                                            let registro = {
                                                ...item,
                                                quantidade_registrada: String(item.quantidade_registrada || 0)
                                                    .split(".")
                                                    .join(","),
                                                quantidade_faturada: String(item.quantidade_faturada || 0)
                                                    .split(".")
                                                    .join(","),
                                                tarifa: String(item.tarifa || 0)
                                                    .split(".")
                                                    .join(","),
                                                valor_imposto: String(item.valor_imposto || 0)
                                                    .split(".")
                                                    .join(","),
                                                valor_total: String(item.valor_total || 0)
                                                    .split(".")
                                                    .join(","),
                                            };
                                            props.setModoTela("exclusao", registro);
                                            props.initForm(registro);
                                        },
                                    },
                                ];

                                return (
                                    <NewTr
                                        key={i + "-" + item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[47, 48, 49].includes(item.id_tipo) ? [] : botoesItens}
                                    >
                                        <Td>{item.nome_produto}</Td>
                                        <Td>
                                            {item.nome_subtipo ? (
                                                <div>
                                                    <div style={{ textDecoration: "line-through", color: "red" }}>{item.nome_tipo}</div>
                                                    <div>{item.nome_subtipo}</div>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        padding: 5,
                                                        marginRight: 80,
                                                        borderRadius: "0.3rem",
                                                        border: state.linhaSelecionada == item.id ? "1px solid #ccc" : "1px solid transparent",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        //se não for um dos admin não exibe os botões
                                                        if (!usuarioLogadoAdmin) return;
                                                        setState({ ...state, linhaSelecionada: state.idItemAlteracaoTipo ? null : item.id });
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        setState({ ...state, linhaSelecionada: null });
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexWrap: "nowrap",
                                                            flexGrow: 1,
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {state.idItemAlteracaoTipo == item.id ? (
                                                            <>
                                                                <Select
                                                                    noFormGroup
                                                                    options={props.listaProdutoTipo.filter((prod) => {
                                                                        //não mostra os produtos relacionados a mercado livre,
                                                                        //pois são definidos apenas pela tela de inclusão de fatura adicional
                                                                        return ![47, 48, 49].includes(prod.id_tipo);
                                                                    })}
                                                                    cols="12 12 12 12"
                                                                    placeholder="Selecione o tipo"
                                                                    value={state.id_tipo}
                                                                    onChange={(value) => {
                                                                        setState({
                                                                            ...state,
                                                                            id_tipo: value,
                                                                        });
                                                                    }}
                                                                />
                                                                <button
                                                                    style={{
                                                                        borderRadius: "0.3rem",
                                                                        marginTop: 5,
                                                                        padding: "5px 10px",
                                                                        color: "#FFF",
                                                                        backgroundColor: "#F44",
                                                                        height: "fit-content",
                                                                        outline: "none",
                                                                    }}
                                                                    disabled={props.faturaFormularioValues.importacao_validada || props.visualizacao || !usuarioLogadoAdmin}
                                                                    onClick={() => {
                                                                        setState({
                                                                            ...state,
                                                                            idItemAlteracaoTipo: null,
                                                                            id_tipo: null,
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                                <button
                                                                    style={{
                                                                        borderRadius: "0.3rem",
                                                                        marginTop: 5,
                                                                        padding: "5px 8px",
                                                                        color: "#FFF",
                                                                        backgroundColor: "#39d139",
                                                                        height: "fit-content",
                                                                        outline: "none",
                                                                    }}
                                                                    disabled={props.faturaFormularioValues.importacao_validada || props.visualizacao || !usuarioLogadoAdmin}
                                                                    onClick={() => {
                                                                        props.redefinirTipo({
                                                                            id: item.id_produto,
                                                                            id_tipo: state.id_tipo,
                                                                            id_fatura: props.faturaFormularioValues.id,
                                                                        });
                                                                        setState({
                                                                            ...state,
                                                                            idItemAlteracaoTipo: null,
                                                                            id_tipo: null,
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="fas fa-check"></i>
                                                                </button>
                                                            </>
                                                        ) : (
                                                            item.nome_tipo || (
                                                                <div
                                                                    style={{
                                                                        boxShadow: state.linhaSelecionada == item.id ? null : "0px 0px 3px 1px #ff2929",
                                                                        borderRadius: 5,
                                                                        height: 30,
                                                                        width: 250,
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        color: state.linhaSelecionada == item.id ? null : "#ff2929",
                                                                    }}
                                                                >
                                                                    {state.linhaSelecionada == item.id ? null : "SEM TIPO"}
                                                                </div>
                                                            )
                                                        )}
                                                    </div>

                                                    {state.idItemAlteracaoTipo || [47, 48, 49].includes(item.id_tipo) || item.id_subtipo ? null : (
                                                        <button
                                                            style={{
                                                                visibility: state.linhaSelecionada == item.id ? "visible" : "hidden",
                                                                borderRadius: "0.3rem",
                                                                outline: "none",
                                                                padding: "5px 8px",
                                                                color: `${item.id_tipo ? "#000" : "#FFF"}`,
                                                                backgroundColor: `${item.id_tipo ? "#Fd2" : "#05F"}`,
                                                            }}
                                                            disabled={props.faturaFormularioValues.importacao_validada || props.visualizacao || !usuarioLogadoAdmin}
                                                            onClick={() => {
                                                                setState({
                                                                    ...state,
                                                                    idItemAlteracaoTipo: item.id,
                                                                    id_tipo: item.id_tipo,
                                                                    linhaSelecionada: null,
                                                                });
                                                            }}
                                                        >
                                                            <i className={`fas ${item.id_tipo ? "fa-pencil-alt" : "fa-plus"}`}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </Td>
                                        <Td>{item.nome_unidade_medida}</Td>
                                        <Td alignRight>
                                            {String(item.quantidade_registrada || 0)
                                                .split(".")
                                                .join(",")}
                                        </Td>
                                        <Td alignRight>
                                            {String(item.quantidade_faturada || 0)
                                                .split(".")
                                                .join(",")}
                                        </Td>
                                        <Td alignRight>
                                            {String(item.tarifa || 0)
                                                .split(".")
                                                .join(",")}
                                        </Td>
                                        <Td alignRight>
                                            {String(item.valor_imposto || 0)
                                                .split(".")
                                                .join(",")}
                                        </Td>
                                        <Td alignRight>
                                            {String(item.valor_total || 0)
                                                .split(".")
                                                .join(",")}
                                        </Td>
                                    </NewTr>
                                );
                            })}

                            <Tr>
                                <Td>Total</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td alignRight></Td>
                                <Td alignRight></Td>
                                <Td alignRight></Td>
                                <Td alignRight></Td>
                                <Td alignRight>{(valorTotal.value || 0).toFixed(5).split(".").join(",")}</Td>
                                <Td alignRight minWidth={100}></Td>
                            </Tr>
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function importar() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <div className="form-group">
                        <div className="custom-file">
                            <input
                                className="custom-file-input"
                                type="file"
                                id="customFile"
                                accept="application/pdf"
                                value={state.file}
                                onChange={(event) => {
                                    event.preventDefault();
                                    let reader = new FileReader();
                                    let file = event.target.files[0];

                                    if (!file.type.includes("application/pdf")) {
                                        //toastr.error('Erro', 'Selecione apenas PDF.');
                                        return;
                                    }

                                    reader.onloadend = () => {
                                        props.importar(props.faturaFormularioValues && props.faturaFormularioValues.id ? props.faturaFormularioValues.id : null, reader.result);
                                    };

                                    reader.readAsDataURL(file);
                                }}
                            />
                            <label className="custom-file-label" for="customFile">
                                Selecione
                            </label>
                        </div>
                    </div>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button text="Cancelar" type={"danger"} icon={"fa fa-times"} event={() => props.setModoTela("lista")} />
                        </Grid>
                    </Row>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function limpar() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <span>Ao confirmar a exclusão, todos os itens dessa fatura serão removidos. Deseja realmente limpar os itens da fatura?</span>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button
                                text="Confirmar Exclusão"
                                type={"danger"}
                                icon={"fa fa-trash"}
                                event={() => {
                                    props.limpar(props.lista);
                                }}
                            />
                        </Grid>

                        <Grid cols="6 6 4 3">
                            <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("lista")} />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </ContentCard>
        );
    }

    return (
        <div>
            {state.exibirModalMercadoLivre ? (
                <ModalAlert titulo="Importação de Custos de Mercado Livre" handleClose={() => setState({ ...state, exibirModalMercadoLivre: false })}>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tbody>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td style={{ paddingInline: 50 }}>Custo Energia ACL Longo Prazo</td>
                                <td style={{ textAlign: "center", verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_lp ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_lp ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "47%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_lp ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"warning"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    id_produto: 19958,
                                                    nomePdf: `Custo_Energia_ACL_LP_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(0, 2)}-${String(
                                                        competencia
                                                    ).substring(3)}`,
                                                });
                                            }}
                                        />
                                        <div>NF-e</div>
                                    </div>
                                </td>

                                <td style={{ verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_lp ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_lp ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "43%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_lp ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"warning"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    id_produto: 20277,
                                                    nomePdf: `Boleto_Energia_ACL_LP_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                        competencia
                                                    ).substring(0, 4)}`,
                                                });
                                            }}
                                        />
                                        <div>Boleto</div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td style={{ paddingInline: 50 }}>Custo Energia ACL Curto Prazo</td>
                                <td style={{ textAlign: "center", verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_cp ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_cp ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "47%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_custo_energia_acl_cp ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"warning"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    nomePdf: `Custo_Energia_ACL_CP_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                        competencia
                                                    ).substring(0, 4)}`,
                                                    id_produto: 19959,
                                                });
                                            }}
                                        />
                                        <div>NF-e</div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_cp ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_cp ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "43%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_boleto_energia_acl_cp ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"warning"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    id_produto: 20278,
                                                    nomePdf: `Boleto_Energia_ACL_CP_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                        competencia
                                                    ).substring(0, 4)}`,
                                                });
                                            }}
                                        />
                                        <div>Boleto</div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td style={{ paddingInline: 50 }}>Custo Gestão ACL</td>
                                <td style={{ textAlign: "center", verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_custo_gestao_acl ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_custo_gestao_acl ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "47%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_custo_gestao_acl ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"dark"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    nomePdf: `Custo_Gestão_ACL_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                        competencia
                                                    ).substring(0, 4)}`,
                                                    id_produto: 19002,
                                                });
                                            }}
                                        />
                                        <div>NF-e</div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_boleto_gestao_acl ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_boleto_gestao_acl ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "43%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_boleto_gestao_acl ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"dark"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    id_produto: 20279,
                                                    nomePdf: `Boleto_Gestão_ACL_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                        competencia
                                                    ).substring(0, 4)}`,
                                                });
                                            }}
                                        />
                                        <div>Boleto</div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td style={{ paddingInline: 50 }}>Tx. Contribuição Associativa CCEE</td>
                                <td style={{ textAlign: "center", verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_contribuicao_associativa_ccee ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_contribuicao_associativa_ccee ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "47%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_contribuicao_associativa_ccee ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"info"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    nomePdf: `Custo_Contribuição_Associativa_CCEE_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(
                                                        4,
                                                        6
                                                    )}-${String(competencia).substring(0, 4)}`,
                                                    id_produto: 19003,
                                                });
                                            }}
                                        />
                                        <div>NF-e</div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <div style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center" }}>
                                        <i
                                            className={props.faturaFormularioValues.arquivo_pdf_boleto_contribuicao_associativa_ccee ? "fas fa-check" : "fas fa-times"}
                                            style={{
                                                color: props.faturaFormularioValues.arquivo_pdf_boleto_contribuicao_associativa_ccee ? "#2cdf2c" : "red",
                                                position: "absolute",
                                                top: 27,
                                                left: "43%",
                                                fontSize: "0.8rem",
                                            }}
                                        ></i>
                                        <ButtonTable
                                            style={{ margin: 0 }}
                                            title={props.faturaFormularioValues.arquivo_pdf_boleto_contribuicao_associativa_ccee ? "Visualizar PDF" : "Incluir PDF"}
                                            type={"info"}
                                            icon={"fas fa-file-pdf"}
                                            visible={true}
                                            event={() => {
                                                setState({ ...state, exibirModalMercadoLivre: false });
                                                const { competencia, nome_unidade_consumidora } = props.faturaFormularioValues;
                                                props.carregarPdfFaturaAdicional({
                                                    modo_tela: "fatura_adicional",
                                                    registro: {},
                                                    id_produto: 20280,
                                                    nomePdf: `Custo_Contribuição_Associativa_CCEE_UC_${nome_unidade_consumidora.split(" - ")[0]}_${String(competencia).substring(
                                                        4,
                                                        6
                                                    )}-${String(competencia).substring(0, 4)}`,
                                                });
                                            }}
                                        />
                                        <div>Boleto</div>
                                    </div>
                                </td>
                            </tr>
                            {props.usuarioLogado.acesso_cliente || !(props.faturaFormularioValues.erros_mercado_livre || []).length ? null : (
                                <tr style={{ borderBottom: "1px solid #ccc", color: "red" }}>
                                    <td colSpan={3} style={{ paddingInline: 50 }}>
                                        <b>Erros de Importação</b>
                                        <ul style={{ padding: 0 }}>
                                            {(props.faturaFormularioValues.erros_mercado_livre || []).map((item) => (
                                                <li>{item}</li>
                                            ))}
                                        </ul>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </ModalAlert>
            ) : null}
            <Content>
                {props.modoTela === "fatura_adicional" || props.modoTela === "fatura_adicional_exclusao" ? null : (
                    <Row style={{ backgroundColor: "#FFF" }}>
                        <Grid cols="12 12 12 12">
                            <label>Itens</label>
                        </Grid>
                    </Row>
                )}
                {props.modoTela === "fatura_adicional" ? <FormFaturaAdicional onSubmit={props.salvarFaturaAdicional} /> : null}
                {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela === "importar" || props.modoTela === "refaturar" ? importar() : null}
                {props.modoTela === "limpar" ? limpar() : null}
                {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela === "lista" ? lista() : null}
            </Content>
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.faturaItem.modoTela,
    lista: state.faturaItem.lista,
    listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
    listaProdutoTipo: state.fatura.listaProdutoTipo,
    aguardando: state.fatura.aguardando,
    faturaFormularioValues: getFormValues("faturaForm")(state),
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            carregarPdfFaturaAdicional,
            salvar,
            salvarFaturaAdicional,
            excluirFaturaAdicional,
            excluir,
            getLista,
            getListaProduto,
            getListaUnidadeMedida,
            importar,
            limpar,
            redefinirTipo,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaItem);
